import React from "react";
import { ICreditResponse, IHistory } from "../../../../store/credit/types";
import PrintCreditSummary from "./PrintCreditSummary";
import PrintCreditHistoryTwoYearPayment from "./PrintCreditHistoryTwoYearPayment";
import PrintCreditHistoryPersonalInfo from "./PrintCreditHistoryPersonalInfo";
import PrintCreditHistoryAddressInfo from "./PrintCreditHistoryAddressInfo";
import PrintCreditHistoryRecentInquiries from "./PrintCreditHistoryRecentInquiries";
import PrintCreditHistoryCreditorContactInfo from "./PrintCreditHistoryCreditorContactInfo";
import PrintCreditScoreAllBureau from "./PrintCreditScoreAllBureau";
import { groupByKey } from "../../../../util/common";
import CreditHistoryTable from "../CreditHistoryTable";

interface IProps {
    data?: ICreditResponse;
    isTUUser?: boolean;
    isOneTimeCreditServiceActive?: boolean;
    reportSummaryHeader?: any;
}
const PrintCreditReport: React.FunctionComponent<IProps> = (props) => {
    const selectHistory = () => {
        if (props.data != null) {
            var groupData = groupByKey(props.data.creditReport.history, "mappingKey");
            return (
                <div className="box offset-padding">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-text">
                                <h2 className="box-title" id="credit-score-trend-title">
                                    Credit History
                                </h2>
                            </div>
                        </div>
                        <div className="box-description"></div>
                        <div className="box-actions"></div>
                    </div>
                    <div className="box-content">
                        {Object.entries(groupData).map(([key, val], index) => (
                            <React.Fragment>
                                <CreditHistoryTable groupData={val as IHistory[]} />
                                <div className="margin-vertical-xl"></div>
                                <PrintCreditHistoryTwoYearPayment groupData={val as IHistory[]} />
                                <p style={{ pageBreakAfter: "always" }}></p>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            );
        }
    };

    return (
        <React.Fragment>
            {props.data != null ? (
                <React.Fragment>
                    {(props.data.scores != null && props.data.scores.length > 0) ? (
                            <PrintCreditScoreAllBureau data={props.data} isTUUser={props.isTUUser} />
                        ) : null}
                    <PrintCreditSummary data={props.data} isOneTimeCreditServiceActive={props.isOneTimeCreditServiceActive} reportSummaryHeader={props.reportSummaryHeader}/>
                    <p style={{ pageBreakAfter: "always" }}></p>
                    {selectHistory()}

                    {props.data.creditReport != null ? (
                        <React.Fragment>
                            <p style={{ pageBreakAfter: "always" }}></p>

                            {props.data.creditReport.personalInformation ? (
                                <PrintCreditHistoryPersonalInfo data={props.data.creditReport.personalInformation} />
                            ) : null}

                            {props.data.creditReport.addressInformation ? (
                                <PrintCreditHistoryAddressInfo data={props.data.creditReport.addressInformation} />
                            ) : null}

                            <p style={{ pageBreakAfter: "always" }}></p>
                            {props.data.creditReport.recentInquiries ? <PrintCreditHistoryRecentInquiries data={props.data.creditReport.recentInquiries} /> : null}

                            <p style={{ pageBreakAfter: "always" }}></p>
                            {props.data.creditReport.contactInformation ? (
                                <PrintCreditHistoryCreditorContactInfo data={props.data.creditReport.contactInformation} />
                            ) : null}
                        </React.Fragment>
                    ) : null}
                </React.Fragment>
            ) : null}
        </React.Fragment>
    );
};

export default PrintCreditReport;
